import { render, staticRenderFns } from "./modalManageModuleAccessTenant.vue?vue&type=template&id=df072316&"
import script from "./modalManageModuleAccessTenant.vue?vue&type=script&lang=js&"
export * from "./modalManageModuleAccessTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports